import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";
import { ThemeProvider } from "./contexts/ThemeContext";
import { useEffect } from "react";

function TitleUpdater() {
  const { t, i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const updateTitle = () => {
      const title = t("page.title");
      document.title = title && title !== "page.title" ? title : "TupIM — All-Round Privacy Protection with Private Chat | Group Chat | Secure Messages & More";
    };
    updateTitle();
  }, [t, i18nInstance.language]);

  return null;
}

function App() {
  return (
    <ThemeProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <TitleUpdater />
          <AppRoutes />
        </BrowserRouter>
      </I18nextProvider>
    </ThemeProvider>
  );
}

export default App;